<template>
    <v-dialog persistent
              v-model="show"
              width="500px">
        <v-card>
            <v-card-title>Contact Person</v-card-title>
            <v-card-text>
                <v-row class="pb-0">
                    <v-col cols="12">
                        <v-select
                                :disabled="isLoading"
                                :items="brokerFirmContactDesignations"
                                item-text="value"
                                item-value="key"
                                label="Designation"
                                v-model="currentContact.designation"/>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field
                                :disabled="isLoading"
                                :rules="[rules.lengthRule(100)]"
                                label="Name"
                                v-model="currentContact.name"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field
                                :disabled="isLoading"
                                :rules="[rules.lengthRule(100)]"
                                label="Surname"
                                v-model="currentContact.surname"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field
                                :disabled="isLoading"
                                :rules="[rules.lengthRule(100)]"
                                label="Email"
                                v-model="currentContact.email"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field
                                :disabled="isLoading"
                                :rules="[rules.lengthRule(100)]"
                                label="Number"
                                v-model="currentContact.number"
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-btn @click="close"
                       class="text-none"
                       color="secondary darken-1"
                       text
                >Close
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn :disabled="isLoading"
                       :loading="isLoading"
                       @click="saveContact"
                       class="text-none"
                       color="secondary darken-1"
                       text>Save
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import brokerFirmService from "@/services/brokerfirm.service";

export default {
    name: "BrokerFirmContactAddEditDialog",
    props: ['brokerFirmId', 'show', 'contact'],
    data() {
        return {
            isLoading: false,
            brokerFirmContactDesignations: [],
            currentContact: {
                id: 0,
                name: "",
                surname: "",
                email: "",
                number: "",
                designation: 1,
            },
            rules: {
                requiredRule: v => !!v || "required",
                lengthRule: limit => v => !v || v.length <= limit || "exceeds " + limit + " characters",
            }
        }
    },
    methods: {
        saveContact() {
            this.isLoading = true;

            if (this.currentContact.id > 0) {
                this.updateContact();
            } else {
                this.addContact();
            }
            this.isLoading = false;
        },
        async loadBrokerFirmContactDesignations() {
            this.brokerFirmContactDesignations = await brokerFirmService.getBrokerFirmContactDesignations();
        },
        async addContact() {
            let brokerFirmCompanyContact = this.currentContact;
            brokerFirmCompanyContact.brokerFirmId = this.brokerFirmId;
            await brokerFirmService.addBrokerFirmContact(brokerFirmCompanyContact);
            this.currentContact = {
                id: 0,
                name: "",
                surname: "",
                email: "",
                number: "",
                designation: 1,
            };
            this.$emit("contact-added");
        },
        async updateContact() {
            console.log('update contact');
            let brokerFirmCompanyContact = this.currentContact;
            brokerFirmCompanyContact.brokerFirmId = this.brokerFirmId;
            await brokerFirmService.updateBrokerFirmContact(brokerFirmCompanyContact);
            this.currentContact = {
                id: 0,
                name: "",
                surname: "",
                email: "",
                number: "",
                designation: 1,
            };
            this.$emit("contact-updated");
        },
        close() {
            this.$emit('close');
        },
        resetAndClose() {
            this.isLoading = false;
            this.currentContact = {
                name: "",
                surname: "",
                email: "",
                number: "",
                designation: 1,
            };
            this.close();
        }
    },
    created() {
        this.loadBrokerFirmContactDesignations();
    },
    watch: {
        contact(newValue) {
            if (this.contact != null) {
                this.currentContact = newValue;
            }
        }
    }
}
</script>

<style scoped>

</style>
